import React from "react";
import Toast from "./Toast";
import "./styles.css";
import { useToast } from "../../context/ToastProvider";

const ToastList: React.FC = () => {
  const { toasts, clearToast } = useToast();

  return (
    <div
      className={`toast-list`}
      aria-live="assertive"
      style={{ zIndex: 1000000 }}
    >
      {toasts.map((toast: any) => (
        <Toast
          key={toast.id}
          headerText={toast.headerText}
          message={toast.message}
          type={toast.type}
          clearToast={() => clearToast(toast.id)}
          id={toast.id}
        />
      ))}
    </div>
  );
};

export default ToastList;
